'use client';

import { NumberInput, rem, type NumberInputProps } from '@mantine/core';
import { useState, forwardRef, useEffect } from 'react';
import classes from '../floating-label-input.module.css';

export type FloatingLabelNumberInputProps = NumberInputProps;

const FloatingLabelNumberInput = forwardRef<
  HTMLInputElement,
  FloatingLabelNumberInputProps
>((props, ref) => {
  const [value, setValue] = useState(props.value);
  const [focused, setFocused] = useState(false);
  const floating =
    (focused || (value && String(value).length > 0)) ?? undefined;

  useEffect(() => {
    setValue(props.value);
  }, [props.value]);

  return (
    <NumberInput
      leftSectionWidth={
        props.leftSection && !props.leftSectionWidth ? rem(48) : undefined
      }
      rightSectionWidth={
        props.rightSection && !props.rightSectionWidth ? rem(48) : undefined
      }
      thousandSeparator="."
      decimalSeparator=","
      {...props}
      ref={ref}
      labelProps={{
        'data-floating': floating,
        'data-with-left-section': props.leftSection ? true : undefined,
        'data-with-right-section': props.rightSection ? true : undefined,
      }}
      classNames={{
        root: classes.root,
        input: classes.input,
        label: classes.label,
      }}
      onFocus={(event) => {
        setFocused(true);
        props.onFocus?.(event);
      }}
      onBlur={(event) => {
        setFocused(false);
        props.onBlur?.(event);
      }}
      value={value}
      onChange={(value) => {
        setValue(value);
        props.onChange?.(value);
      }}
    />
  );
});

FloatingLabelNumberInput.displayName = 'FloatingLabelNumberInput';

export default FloatingLabelNumberInput;
